import { Nature } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import BaseProfilEcritureRecette from './Base/BaseProfilEcritureRecette';
import ProjetPanel from '../panel/ProjetPanel';
import InventairePanel from '../panel/InventairePanel';
import SaisieLibrePanel from '../panel/InformationsRattachement/SaisieLibrePanel';

class ProfilEcritureOrdreBudgetaireSectInvestissementAvecInfoInvRecette extends BaseProfilEcritureRecette {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.RECETTE.ORDRE_BUDG_INTERIEUR_SECT_INVES_AVEC_INFO_INV;
    this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.RECETTE.INVENTAIRE;
    this.typePiece = TYPE_PIECE.RECETTE.ORDRE_BUDGET;
    this.imputation.nature = Nature.ORDRE;
    this.imputation.chapitre = '041';
    this.codesProduitLocal = ['102', '107'];
    this.panels = [
      ...this.panels,
      new SaisieLibrePanel(),
      new InventairePanel(true),
      new ProjetPanel(),
      // TODO : add "Marche public" optional panel
    ];
  }
}

export default ProfilEcritureOrdreBudgetaireSectInvestissementAvecInfoInvRecette;
